import styles from './TerminalHeader.module.css'

export function TerminalHeader() {
  return (
    <div className={styles.header}>
      <div className={styles.buttons}>
        <span className={`${styles.btn} ${styles.close}`}></span>
        <span className={`${styles.btn} ${styles.minimize}`}></span>
        <span className={`${styles.btn} ${styles.maximize}`}></span>
      </div>
      <div className={styles.title}>sroy@terminal:~</div>
    </div>
  )
}

